import React from 'react';
import { titoloFase, coloreFase } from '../../../../components/planning/fasiPlanning';

const DesktopPlanningView = ({
  matches,
  maxTurno,
  maxCampo,
  getMatchAtPosition,
  getMatchWinner,
  getMatchColor,
  fasiRaggruppate
}) => {
  return (
    <div className="qrp-desktop-planning-container">
      <table className="qrp-planning-table">
        <thead>
          {/* Header delle fasi */}
          <tr className="qrp-fase-header">
            <th className="qrp-empty-corner"></th>
            {fasiRaggruppate.map((faseInfo) => (
              <th
                key={`fase-${faseInfo.fase}`}
                colSpan={faseInfo.count}
                className="qrp-fase-header-cell"
                style={{ '--fase-colore': coloreFase(faseInfo.fase) }}
              >
                <div className="qrp-fase-header-content">
                  <span className="qrp-fase-title">
                    {titoloFase(faseInfo)}
                  </span>
                </div>
              </th>
            ))}
          </tr>
          {/* Header dei turni */}
          <tr>
            <th>Campo \\ Turno</th>
            {Array.from({ length: maxTurno }, (_, i) => (
              <th key={i + 1}>
                Turno {i + 1}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: maxCampo }, (_, campoIdx) => {
            const campo = campoIdx + 1;
            return (
              <tr key={campo}>
                <td className="qrp-campo-header">
                  Campo {campo}
                </td>
                {Array.from({ length: maxTurno }, (_, turnoIdx) => {
                  const turno = turnoIdx + 1;
                  const match = getMatchAtPosition(turno, campo);
                  
                  return (
                    <td 
                      key={`${turno}-${campo}`}
                      className="qrp-match-cell"
                    >
                      {match ? (
                        <div 
                          className="qrp-match-card"
                          style={{ 
                            background: getMatchColor(match),
                            border: match.risultato ? '2px solid #333' : 'none',
                            display: 'grid',
                            gridTemplateColumns: getMatchWinner(match) ? '30px 1fr auto' : '1fr',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '4px'
                          }}
                          title={match.nome}
                        >
                          {getMatchWinner(match) && (
                            <div 
                              style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                color: '#333',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                gridRow: '1 / -1'
                              }}
                            >
                              {getMatchWinner(match)}
                            </div>
                          )}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <div className="qrp-match-team" style={{ margin: 0 }}>
                              {match.squadra1}
                            </div>
                            <div className="qrp-match-team" style={{ margin: 0 }}>
                              {match.squadra2}
                            </div>
                          </div>
                          {match.risultato && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '11px' }}>
                              <div>{match.risultato.mete1}-{match.risultato.pieni1}-{match.risultato.vuoti1}</div>
                              <div>{match.risultato.mete2}-{match.risultato.pieni2}-{match.risultato.vuoti2}</div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="qrp-empty-cell">-</div>
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DesktopPlanningView;